module.exports = __webpack_public_path__ + "img/bindez_logo.647c0c59.svg";